import SearchFilter from 'components/home/messages/search-filter';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Table } from 'semantic-ui-react';
import type { CommunicationData } from 'types';
import { CommunicationHelper } from 'utils';

import UnknownCallListRow from './unknownCallLogRow';

type FilterType = 'phone' | 'email';

type UnknownCallLogTableProps = {
  communicationsData: CommunicationData;
  communicationsMutate: () => Promise<CommunicationData | undefined>;
  handleErrorMessage: (errorMessage: string) => void;
  archived: boolean;
};

const UnknownCallLogTable: React.FC<UnknownCallLogTableProps> = ({
  communicationsData,
  communicationsMutate,
  handleErrorMessage,
  archived,
}) => {
  const _navigate = useNavigate();

  const [filteredData, setFilteredData] = useState(communicationsData.entry);

  useEffect(() => {
    setFilteredData(communicationsData.entry);
  }, [communicationsData.entry]);

  const handleFilterChange = ({ type, value }: { type: FilterType; value: string }) => {
    if (!value) {
      setFilteredData(communicationsData.entry);
      return;
    }

    const filtered = communicationsData.entry.filter((entry) => {
      const helper = new CommunicationHelper(entry.resource);

      if (type === 'phone') {
        return helper.getMemberPhoneNumber() === value;
      }

      if (type === 'email') {
        return helper.getMemberEmail() === value;
      }

      return false;
    });

    setFilteredData(filtered);
  };

  return (
    <div className="table-div-message">
      <SearchFilter
        filterOptions={[
          { key: 'phone', text: 'Phone Number', value: 'phone', icon: 'phone' },
          { key: 'email', text: 'Email Address', value: 'email', icon: 'mail' },
        ]}
        defaultFilterType="phone"
        autoApply
        onFilterChange={handleFilterChange}
        inputLabelMap={{
          phone: 'Phone Number',
          email: 'Email Address',
        }}
      />
      <Table basic sortable celled singleLine>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Engagement ID</Table.HeaderCell>
            <Table.HeaderCell>Phone/Email</Table.HeaderCell>
            <Table.HeaderCell>User</Table.HeaderCell>
            <Table.HeaderCell>Channel</Table.HeaderCell>
            <Table.HeaderCell>Subject</Table.HeaderCell>
            <Table.HeaderCell>Content</Table.HeaderCell>
            <Table.HeaderCell>Date & Time</Table.HeaderCell>
            <Table.HeaderCell>Assign Member</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {filteredData.map((communication, index) => (
            <UnknownCallListRow
              key={index}
              communicationsMutate={communicationsMutate}
              communicationResource={communication.resource}
              handleErrorMessage={handleErrorMessage}
              archived={archived}
            />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};

export default UnknownCallLogTable;
